class Session {
    token;
    geolocation;
    constructor(token, geolocation) {
        this.token = token;
        this.geolocation = geolocation;
    }
}
export default Session;
